const category = {
  getAllCategories: async function() {
    return await this.$store.getters
      .fetcher({
        query: `{ categories {
          Category_Id
          Name
        }
      }`
      })
      .then(r => {
        return r.data.categories;
      });
  },

  createCategory: async function(name) {
    const query = `mutation($name: String!){ CreateCategory(name: $name){
          Category_Id
          Name
        }}`;
    const variables = {
      name: name.trim()
    };
    return await this.$store.getters.fetcher({ query, variables }).then(r => {
      return r.data.CreateCategory;
    });
  }
};

export { category };
